/**
 * `editions` — un exemplaire d'une édition (base galerie, 4.1).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, centimesPositifsSchema, deviseSchema, idSchema, withAudit, } from './commun.js';
import { statutOeuvreSchema } from './artworks.js';
/** Nature de l'exemplaire. */
export const TYPES_EXEMPLAIRE = [
    'numerote',
    'epreuve_artiste',
    'epreuve_essai',
    'hors_commerce',
];
export const typeExemplaireSchema = z.enum(TYPES_EXEMPLAIRE);
export const editionSchema = withAudit(z.object({
    _id: idSchema,
    oeuvreId: idSchema,
    /** Tel qu'il s'écrit sur le cartel : « 1/5 », « EA 1/2 ». */
    numero: z.string().min(1),
    type: typeExemplaireSchema.default('numerote'),
    statut: statutOeuvreSchema.default('disponible'),
    prixCentimes: centimesPositifsSchema.optional(),
    devise: deviseSchema.optional(),
    localisationId: idSchema.optional(),
}));
export const editionCreationSchema = editionSchema.omit({ ...CHAMPS_DOCUMENT, statut: true });
export const editionMiseAJourSchema = editionCreationSchema.omit({ oeuvreId: true }).partial();
//# sourceMappingURL=editions.js.map